import { Card, Skeleton, message } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import Back from "../../../../assets/icons/back.svg";
import colors from "../../../../share/constants/constants";
import Button from "../../../../components/common/button";
import {
  approveBusiness,
  getBusinessAnalytics,
  getBusinessById,
  giveFreeAds,
} from "../../../../api/business";
import { useEffect, useState } from "react";
import { addPromoCode, getPromoCode } from "../../../../api/user";
import DeleteMemberModal from "../../../../components/common/modalMember";
import PromoModal from "../../../../components/common/ModalPromo";
import HorizontalNav from "../../../../components/common/horizontalNav";
import AnalyticsCard from "./AnalyticsCard";
import AllServices from "../../home/services";
import PasswordModal from "../../../../components/common/passModal";
import YupupCutModal from "../../../../components/common/cutModal";
import FreeAdsModal from "../../../../components/common/freeAdsModal";
import YupupQuantityModal from "../../../../components/common/quantityModal";

const RequestDetail = ({
  member = "lorem ipsum",
  phone = "012312222",
  email = "test@example.com",
}) => {
  let { id } = useParams();

  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addPromo, setAddPromo] = useState(false);
  const [selectedKey, setSelectedKey] = useState("analytics");
  const [approveModal, setApproveModal] = useState(false);
  const [promo, setPromo] = useState();
  const [passModal, setPassModal] = useState(false);
  const [cutModal, setCutModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [adsModalOpen, setAdsModalOpen] = useState(false);
  const [analyticsData, setAnalyticsData] = useState();
  const [render, setRender] = useState(false);
  const [onChangeState, setOnChangeState] = useState(false);
  const [quntityModal, setQuntityModal] = useState(false);

  const navigate = useNavigate();
  const showApproveModal = () => {
    setApproveModal(true);
  };
  const approveBusinessAccount = async (isChequePayment) => {
    const payload = {
      isApproved: true,
      promoCode: promo,
    };
    if (isChequePayment) {
      payload.isChequePayment = true;
    }
    const res = await approveBusiness(id, payload);
    if (res) {
      message.success("Approved Successfully!");
      // navigate("/main/manage-requests");
    }
    getBusinessDetails(id);
  };

  // Give Free Ads API Call
  const updateGiveFreeAds = async (payload) => {
    const res = await giveFreeAds(payload);
    if (res) {
      message.success("Successful");
    }
  };

  const getAnalytics = async () => {
    const res = await getBusinessAnalytics(id);
    if (res) {
      setAnalyticsData(res);
    }
  };

  const YesPassClick = () => {
    setPassModal(false);
    // setRender(!render);
  };

  const showPasswordModal = () => {
    setPassModal(true);
  };

  const showCutModal = (data) => {
    setCutModal(true);
    // setRender(!render);
  };

  const showQuantityModal = (data) => {
    setQuntityModal(true);
    // setRender(!render);
  };


  const YesClickHandler = () => {
    setIsModalOpen(false);
    setAddPromo(true);
    // setRender(!render);
    // givePromoCode();
  };

  const YesClick = () => {
    setApproveModal(false);
    approveBusinessAccount(onChangeState);
  };

  const NoClick = () => {
    setApproveModal(false);
  };

  // Ads Modal Click Handlers
  const YesAdsClick = () => {
    const payload = {
      businessId: adsModalOpen?.business?._id,
      isFreeAds: true,
    };
    setAdsModalOpen(false);
    updateGiveFreeAds(payload);
  };

  const CancelAdsClick = () => {
    setAdsModalOpen(false);
  };

  const NoAdsClick = () => {
    const payload = {
      businessId: adsModalOpen?.business?._id,
    };
    setAdsModalOpen(false);
    updateGiveFreeAds(payload);
  };

  const hideModal = () => {
    setIsModalOpen(false);
    setPassModal(false);
    setCutModal(false);
    setQuntityModal(false);
  };

  const showModal = (id) => {
    setIsModalOpen(true);
  };

  const getBusinessDetails = async (id) => {
    const res = await getBusinessById(id);
    if (res) {
      setBusiness(res);
      setLoading(false);
    }
  };

  const getPromo = async () => {
    const res = await getPromoCode(id);
    if (res) {
      setPromo(res[0]?.promoCode);
    }
  };

  useEffect(() => {
    setLoading(true);
    getBusinessDetails(id);
    getPromo();
    getAnalytics();
  }, [id]);

  return (
    <div className={`${isModalOpen || approveModal ? "blur-sm" : ""}`}>
      <div className="grid gap-2 space-x-3 w-full pr-3">
        <div className="flex pt-3 pl-3 place-content-between">
          <Link to="/main/manage-requests">
            <div className="flex items-center">
              <img src={Back} alt="Edit Icon" className="mr-1" />
              <span className="text-lg font-bold text-black ml-1">
                New Business Requests
              </span>
            </div>
          </Link>
          {(!loading && business?.business?.isApproved === false) ? (
            <div className="flex items-center">         
              <Button
                title="Approve"
                color={colors.primaryBlue}
                className="w-20 md:w-20 xl:w-20 mr-1"
                onClick={showApproveModal}
              />
              <Button
                title="Reject"
                border={colors.primaryBlue}
                className="text-primaryBlue w-20 md:w-20 xl:w-20 mr-1"
              />
              {!promo && (
                <Button
                  title="Give Promo Code"
                  color={colors.primaryBlue}
                  onClick={showModal}
                  className={`text-primaryBlue w-20 md:w-20 xl:w-20`}
                />
              )}
            </div>
          ) : (
            <div className="flex justify-between items-center">
              {business?.business?.isApproved && (
                <Button
                  title="Approved"
                  border={colors.primaryBlue}
                  className="text-primaryBlue w-20 md:w-20 xl:w-20"
                />
              )}
            </div>
          )}
        </div>
        <div>
          <Card className="border-2 border-gray-200 mr-2 xl:mr-0 bg-white xl:relative">
            {loading &&
              !business &&
              [1, 1, 1].map((m, i) => (
                <div className="flex flex-row" key={i}>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                  <Skeleton
                    paragraph={{ rows: 2, width: [180, 220] }}
                    title={false}
                    loading={true}
                    className="pl-2 pr-2 pt-2"
                  ></Skeleton>
                </div>
              ))}

            {!loading && business && (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 ml-2">
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    First Name
                  </p>
                  <p className="font-medium mt-1">
                    {business?.owner?.firstName}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Last Name
                  </p>
                  <p className="font-medium mt-1">
                    {business?.owner?.lastName}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Email
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.owner?.email}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Phone Number
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.owner?.phoneNumber}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Business Name
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.business?.businessName}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Business Type
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.business?.businessTypeId?.name}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Business Type Cost
                  </p>
                  <p className="font-medium mt-1 break-all">
                    ${business?.business?.businessTypeId?.cost}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Address
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.business?.businessAddress},
                    {business?.business?.city},{business?.business?.state}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Suite/Zip Code
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.business?.suiteNumber} /{" "}
                    {business?.business?.zipCode}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Website
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.business?.website}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Years in Business
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.business?.yearsInBusiness}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Staff size
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.business?.staffSize}
                  </p>
                </div>
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <p className="font-medium text-primaryPurple text-lg mb-0">
                    Owner Name
                  </p>
                  <p className="font-medium mt-1 break-all">
                    {business?.owner?.firstName} {business?.owner?.lastName}
                  </p>
                </div>

                {promo && (
                  <>
                    <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                      <p className="font-medium text-primaryPurple text-lg mb-0">
                        Promo Code
                      </p>
                      <p className="font-medium mt-1 break-all">{promo}</p>
                    </div>
                  </>
                ) }
                {/* <div className="hidden md:block"></div> */}
                <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
                  <Button
                    className="bg-primaryBlue sm:w-full "
                    title={"Give Free Ads"}
                    onClick={() => {
                      setAdsModalOpen(business);
                    }}
                  />
                </div>
                <div className="flex items-center md:hidden sm:block mb-2 ml-1">
                  <u
                    className="flex items-center font-medium  text-primaryPurple text-lg mb-0 hover:cursor-pointer"
                    onClick={() => showCutModal(business)}
                    // data={business}
                  >
                    Edit Yupup's Cut
                  </u>
                </div>
                <div className="hidden md:block mt-1">
                  {/* <Button
                    title={"Change Password"}
                    color={colors.primaryBlue}
                    className="w-19 mt-2"
                    onClick={showPasswordModal}
                  /> */}
                  <u
                    className="font-medium  text-primaryPurple text-lg mb-0 hover:cursor-pointer"
                    onClick={() => showCutModal(business)}
                    // data={business}
                  >
                    Edit YupUp's Cut
                  </u>
                </div>
                <div className="hidden md:block mt-1">
                  {/* <Button
                    title={"Change Password"}
                    color={colors.primaryBlue}
                    className="w-19 mt-2"
                    onClick={showPasswordModal}
                  /> */}
                  <u
                    className="font-medium  text-primaryPurple text-lg mb-0 hover:cursor-pointer"
                    onClick={() => showQuantityModal(business)}
                    // data={business}
                  >
                    Edit Max Quantity
                  </u>
                </div>
              </div>
            )}
          </Card>
          <Card className="mt-2">
            <div className="flex">
              <HorizontalNav selected={(key) => setSelectedKey(key)} />
            </div>
            {selectedKey === "analytics" ? (
              <AnalyticsCard data={analyticsData} />
            ) : (
              <AllServices />
            )}
          </Card>
        </div>
      </div>
      {isModalOpen && (
        <PromoModal
          title="Give Promo Code"
          text="Are you sure you want to Give Promo Code?"
          onCancel={hideModal}
          id={id}
          onOk={YesClickHandler}
        />
      )}
      {passModal && (
        <PasswordModal
          title="Change Password"
          text="Are you sure you want to change password?"
          onCancel={hideModal}
          id={id}
          onOk={YesPassClick}
        />
      )}
      {cutModal && (
        <YupupCutModal
          title="Edit Yupup's Cut"
          // text="Are you sure you want to change password?"
          onCancel={hideModal}
          data={business}
          id={id}
          onOk={YesPassClick}
        />
      )}
      {approveModal && (
        <DeleteMemberModal
          title="Approve Business"
          text="Are you sure you want to approve this business?"
          promo={
            "If you want to give a discount to this business, please generate a Promo Code first."
          }
          onCancel={NoClick}
          onOk={YesClick}
          onChange={(e) => {
            setOnChangeState(e);
          }}
          chequePayment={true}
        />
      )}
      {adsModalOpen && (
        <FreeAdsModal
          title="Give Free Advertisements"
          text="Are you sure you want to give free advertisements to this business?"
          onCancel={CancelAdsClick}
          onOk={YesAdsClick}
          onNo={NoAdsClick}
        />
      )}

      {quntityModal && (
        <YupupQuantityModal
          title="Edit Max Quantity"
          onCancel={hideModal}
          data={business}
          id={id}
          onOk={YesPassClick}
          getBusinessDetails={getBusinessDetails}
        />
      )}
    </div>
  );
};

export default RequestDetail;
